import React, { FunctionComponent } from 'react'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type TextButtonProps = Omit<BaseButtonProps, 'buttonType' | 'size' | 'modifier'>

export const TextButton: FunctionComponent<TextButtonProps> = (props) => (
  <BaseButton {...props} buttonType={ButtonType.TEXT} />
)
